var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_976_171327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9618 19.2712C10.9618 17.5829 11.6324 15.9638 12.8262 14.7701L19.8172 7.77902C20.5453 7.05092 21.7258 7.05092 22.4539 7.77902C23.182 8.50712 23.182 9.68761 22.4539 10.4157L15.4628 17.4068C14.2691 18.6005 12.65 19.2712 10.9618 19.2712ZM10.9618 19.2712H8.45762C8.45762 18.2415 7.62288 17.4068 6.59321 17.4068C5.56355 17.4068 4.72881 18.2415 4.72881 19.2712M20.1901 12.6795L17.5534 10.0428M17.7796 20.3494V21.1356C17.7796 22.1652 16.9449 23 15.9152 23H2.8644C1.83474 23 1 22.1652 1 21.1356V2.8644C1 1.83474 1.83474 1 2.8644 1H13.2785C13.773 1 14.2472 1.19641 14.5969 1.54608L17.2335 4.18272C17.4607 4.40985 17.6232 4.68961 17.7092 4.99332M4.72881 6.59321H10.322M4.72881 10.322H10.322",
    stroke: "#55217E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_976_171327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.9992c9a1.svg";
export { ForwardRef as ReactComponent };